import { render, staticRenderFns } from "./DocumentResultView.vue?vue&type=template&id=31475dfb&scoped=true"
import script from "./DocumentResultView.vue?vue&type=script&lang=ts"
export * from "./DocumentResultView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentResultView.vue?vue&type=style&index=0&id=31475dfb&prod&lang=scss&scoped=true"
import style1 from "./DocumentResultView.vue?vue&type=style&index=1&id=31475dfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31475dfb",
  null
  
)

export default component.exports